import React from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { ReactComponent as DeleteIcon } from "../images/Icons/delete-icon.svg";
import RouteIndicator from "./RouteIndicator";

function AddStopDetails(props) {
  return (
    <div className="setting-stops border-bottom">
      <div className="tracker-id">
        <input
          type="text"
          placeholder="1234"
          maxLength="4"
          className={"text-center" + (props.stop.error ? " input-error" : "")}
          onChange={(event) => props.inputChange(event, props.index)}
          onBlur={(event) => props.inputBlur(event, props.index)}
          onClick={() => props.inputClick(props.index)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              props.addStop(props.index);
            }
          }}
          value={props.stop.trackerID}
          disabled={props.stop.stopInformation}
          id={"input-id-" + props.index}
        />

        <label className="text-red no-margin">{props.stop.error}</label>
      </div>

      <div className="stop-details">
        {props.stop.stopInformation ? (
          <div>
            <div className="stop-description">
              Stop {props.stop.stopInformation.FlagStopNo}:{" "}
              {props.stop.stopInformation.StopName} -{" "}
              {props.stop.stopInformation.CityDirection}
            </div>
            <div className="stop-routes">
              <RouteIndicator
                routeList={props.stop.stopInformation.routes}
                routeColours={props.routeColours}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="stop-description empty">Add a Tram Stop Tracker ID</div>
            <div className="d-flex align-items-center pt-1">
              <Button
                variant="secondary"
                disabled={props.stop.disableButton}
                onClick={() => props.addStop(props.index)}
              >
                ADD
              </Button>
              {props.stop.addButtonSpinner ? <Spinner animation="border" /> : ""}
            </div>
          </div>
        )}
      </div>

      {props.stop.stopInformation ? (
        <div className="stop-delete">
          <Button
            variant="secondary"
            className={"btn-delete" + (props.stop.deleteSelected ? " selected" : "")}
            id={"btn-delete-" + props.index}
            data-index={props.index}
            // onClick={() => props.deleteStop(props.index)}
          >
            <DeleteIcon /> DELETE
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default AddStopDetails;
